import apiAthlete from '@/api/athlete'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  deactivateAthleteStart: '[deactivate athlete] deactivate athlete start',
  deactivateAthleteSuccess: '[deactivate athlete] deactivate athlete success',
  deactivateAthleteFailure: '[deactivate athlete] deactivate athlete failure'
}

export const actionTypes = {
  deactivateAthlete: '[deactivate athlete] deactivate athlete'
}

const mutations = {
  [mutationTypes.deactivateAthleteStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deactivateAthleteSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deactivateAthleteFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deactivateAthlete](context, {athleteId, params}) {
    context.commit(mutationTypes.deactivateAthleteStart)
    return new Promise(resolve => {
      apiAthlete
        .deactivateAthlete(athleteId, params)
        .then(response => {
          context.commit(mutationTypes.deactivateAthleteSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deactivateAthleteFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
